<template>
  <div>
    <div v-if="isAuthenticated" id="navauth">
      <router-link to="/">Home&nbsp;</router-link>|
      <router-link to="/about">About&nbsp;</router-link>|
      <router-link to="/designs?page=1">My designs&nbsp;</router-link>|
      <router-link to="/profile">Profile&nbsp;</router-link>|
      <a href="#" @click="logout">Logout</a>
    </div>
    <div v-if="!isAuthenticated" id="navnotauth">
      <router-link to="/login">Login&nbsp;</router-link>|
      <router-link to="/register">Register</router-link>
    </div>
  </div>
</template>

<script>
import store from "../store";
import { AUTH_LOGOUT } from "../store/actions/auth";

export default {
  name: "Navigation",
  computed: {
    isAuthenticated() {
      return store.getters.isAuthenticated;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
  },
};
</script>

<style lang="scss" scoped>
#navauth {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#navnotauth {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>